import { Link } from 'react-router-dom';

export function PolicyCards() {
  return (
    <div className="policy-cards">
      <div className="policy-card">
        <h4>
          <i className="fa-solid fa-file-contract" /> Terms &amp; Refund Policy
        </h4>
        <p>
          All sales are final. Chargebacks result in a permanent ban. Items are delivered digitally
          upon payment.
        </p>
        <Link to="/terms/" className="policy-card-link">
          Read full policy <i className="fa-solid fa-arrow-right" />
        </Link>
      </div>
      <div className="policy-card">
        <h4>
          <i className="fa-solid fa-scale-balanced" /> Legal &amp; Privacy
        </h4>
        <p>
          We only collect what&apos;s needed to process your order. Your data is never shared with
          third parties.
        </p>
        <Link to="/legal/" className="policy-card-link">
          Read full policy <i className="fa-solid fa-arrow-right" />
        </Link>
      </div>
    </div>
  );
}
